var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.82,17.43a.59.59,0,0,1-.52.31.56.56,0,0,1-.3-.08l-3.29-1.85a.61.61,0,0,1-.31-.52V10a.6.6,0,0,1,1.2,0v4.94l3,1.68A.59.59,0,0,1,18.82,17.43ZM23.6,15A8.6,8.6,0,1,1,15,6.4,8.61,8.61,0,0,1,23.6,15Zm-1.2,0A7.4,7.4,0,1,0,15,22.4,7.41,7.41,0,0,0,22.4,15Z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.fbae87d9a3f54af0c3da761a28a76c59.svg";
export { ForwardRef as ReactComponent };